import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const statItems = [
  { key: "years_active", label: "Years Active", suffix: "+" },
  { key: "total_attendees", label: "Total Attendees", suffix: "+" },
  { key: "speakers", label: "Speakers", suffix: "+" },
  { key: "communities_reached", label: "Communities Reached", suffix: "+" },
];

const Stats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch(console.error);
  }, []);

  if (!stats) return null;

  return (
    <section data-testid="stats-section" className="relative py-16 bg-zinc-900/50 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {statItems.map((item) => (
            <div key={item.key} className="text-center" data-testid={`stat-${item.key}`}>
              <div className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tighter text-white">
                {stats[item.key]?.toLocaleString()}
                <span className="text-teal-500">{item.suffix}</span>
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mt-2 font-medium">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
